import { format } from 'date-fns'

export const isoDateFormat = (d: Date | number = Date.now()) => {
  return format(d, 'yyyy-MM-dd')
}

export const timerFormat = (d: Date | number) => {
  return format(d, 'HH:mm')
}
